var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 14.4766H4.54834V16.9346H8.99995V14.4766Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 19.3164H4.54834V21.7745H8.99995V19.3164Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 24.1543H4.54834V26.6124H8.99995V24.1543Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2258 4.79883H15.7742V7.25689H20.2258V4.79883Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2258 9.63867H15.7742V12.0967H20.2258V9.63867Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4709 19.2969H27.0193V21.7549H31.4709V19.2969Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4709 24.1348H27.0193V26.5928H31.4709V24.1348Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2258 14.4766H15.7742V16.9346H20.2258V14.4766Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9677 15.0968V0H11.0516V9.87097H0V36H11.0516H13.529H22.471H24.9677H36V15.0968H24.9677ZM11.0129 33.4839H2.51613V12.3871H11.0129V33.4839ZM22.4516 33.4839H13.5677V2.51613H22.4516V33.4839ZM33.4839 33.4839H24.9871V17.6129H33.4839V33.4839Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnterprise);
export default __webpack_public_path__ + "static/media/ico-enterprise.78c2a0402e2273d0736efe64c9838b8c.svg";
export { ForwardRef as ReactComponent };